// max values for power zones in Watts
export const powerZonesMax = {
    default: 2000,
    cycling: 2500,
    running: 1000
};
